import { useMemo } from 'react';
import { WriteoffDocumentView } from '../../../../../../services/WriteoffService/types/documentTypes';
import { getFileIcon, getFileTypeLabel } from '../templates';

export interface DocumentGridRow {
  id: string;
  fileName: string;
  extension: string;
  uploadBy: string;
  uploadDate: string;
  uploadDateFormatted: string;
  fileType: string;
  iconEmoji: string;
  document: WriteoffDocumentView;
}

/** Format date for display */
const formatDate = (dateString?: string | null): string => {
  if (!dateString) return 'Unknown';
  try {
    return new Date(dateString).toLocaleString();
  } catch {
    return 'Unknown';
  }
};

/**
 * Hook to transform documents into grid-friendly rows.
 */
export function useDocumentGridData(documents: WriteoffDocumentView[]): DocumentGridRow[] {
  return useMemo(() => {
    return documents
      .filter(doc => !doc.isDeleted)
      .map(doc => ({
        id: doc.id,
        fileName: doc.fileName,
        extension: doc.extension,
        uploadBy: doc.uploadedBy || 'Unknown',
        uploadDate: doc.uploadedDate || '',
        uploadDateFormatted: formatDate(doc.uploadedDate),
        fileType: getFileTypeLabel(doc.extension),
        iconEmoji: getFileIcon(doc.extension),
        document: doc,
      }));
  }, [documents]);
}
